import { render } from "./ToastificationContent.vue?vue&type=template&id=55dd3057&scoped=true"
import script from "./ToastificationContent.vue?vue&type=script&lang=js"
export * from "./ToastificationContent.vue?vue&type=script&lang=js"

import "./ToastificationContent.vue?vue&type=style&index=0&id=55dd3057&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-55dd3057"

export default script